/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { StyledIcon } from '../StyledIcon';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledIconInline = StyledIcon.extend`
  display: inline-block;
  vertical-align: middle;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledIconInline/index.js